<template>
<div>
  <van-field
      v-model="result"
      is-link
      readonly
      name="picker"
      input-align='right'
      :label="label"
      :placeholder="placeholder"
      @click="showPicker = true"
  />
  <van-popup v-model:show="showPicker" position="bottom">
    <van-area 
        title="选择地区"
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
     />
  </van-popup>
</div>
</template>

<script>
import { areaList } from '@vant/area-data';
export default {
  name: "AreaList",
  props:{
    modelValue: Object,
    label:String,
    placeholder:String,
    options:Array,
    optionName:String,
    optionValue:String,
  },
  emits: ['update:modelValue'],
  data(){
    return{
      areaList ,
      result:"",
      columnsFieldNames:{
        text:"label",
        value:"value",
      },
      showPicker:false,
    }
  },

  mounted(){
    if(this.optionName!=null){
      this.columnsFieldNames.text=this.optionName
    }
    if(this.optionValue!=null){
      this.columnsFieldNames.value=this.optionValue
    }
    if(this.options!=null){
      var d={}
      d[this.columnsFieldNames.text]="无"
      this.options.push(d)
    }
    if(this.modelValue!=null){
      for(var key in this.options){
        if(this.options[key][this.columnsFieldNames.value]==this.modelValue){
          this.result=this.options[key][this.columnsFieldNames.text]
        }
      }
    }

  },
  watch:{
    modelValue:function () {
      if(this.modelValue!=null){
        for(var key in this.options){
          if(this.options[key][this.columnsFieldNames.value]==this.modelValue){
            this.result=this.options[key][this.columnsFieldNames.text]
          }
        }
      }
    }
  },
  methods:{

    onConfirm(value){
        console.log(value)
      this.result = value.filter((item) => !!item).map((item) => item.name).join('/');
      this.$emit('update:modelValue',this.result)
      this.showPicker = false;
    }
  }

}
</script>

<style scoped>

</style>
